jQuery(document).ready(function($) {
  const isIpad = /iPad|Macintosh/.test(navigator.userAgent) && 
               navigator.maxTouchPoints > 1;
  if((window.matchMedia("only screen and (max-width: 1399px)").matches && isIpad) || window.matchMedia("only screen and (max-width: 989px)").matches){
     $('.brand-list .owl-carousel').each((index,item) => {
      $(item).removeClass("owl-carousel")
      $(item).addClass("mobile-carousel")
    
     });
  }else{
    $('.brand-list .owl-carousel').each((index,item) => {
		$(item).owlCarousel({
			loop:false,
            // rewind: true,
			margin:10,
			nav:true,
			dots: false,
			responsive:{
					0:{
							items: 3.2,
							margin:10,
                          slideBy: 1
					},
					989:{
							items: 8.5,
							margin:15,
                            slideBy: 6
					}
			}
		})
	})
   }
});